// src/features/patients/constants/searchConstants.js

export const ADDRESS_FIELDS = [
  "street",
  "city",
  "city_code",
  "country",
];
export const ADDITIONAL_FIELDS = [];
export const SEARCH_DEBOUNCE_MS = 500;

export const TRANSLATION_KEYS = {
  // Main fields
  first_name: "6",
  last_name: "7",
  birthday: "8",
  gender: "9",
  // Address fields
  street: "10",
  city: "11",
  city_code: "13",
  country: "14",
  // Gender options
  genderOption1: "28",
  genderOption2: "29",
};
